import { Outlet, useNavigate, useLocation } from 'react-router-dom'
import { useApp } from '../AppContext'

const NAV_ADMIN = [
  { path: '/',            icon: 'layout-dashboard', label: 'Tableau de bord' },
  { path: '/contacts',    icon: 'users',            label: 'Contacts' },
  { path: '/documents',   icon: 'files',            label: 'Documents' },
  { path: '/produits',    icon: 'package',          label: 'Produits / Services' },
  { path: '/alertes',     icon: 'bell',             label: 'Alertes / Relances' },
  { path: '/credentials', icon: 'key',              label: 'Credentials' },
  { path: '/equipe',      icon: 'users-group',      label: 'Mon équipe' },
  { path: '/rapports',    icon: 'report',           label: 'Rapports' },
  { path: '/parametres',  icon: 'settings',         label: 'Paramètres' },
]

const NAV_TECH = [
  { path: '/',            icon: 'layout-dashboard', label: 'Tableau de bord' },
  { path: '/alertes',     icon: 'bell',             label: 'Alertes / Relances' },
  { path: '/rapports',    icon: 'report',           label: 'Mes rapports' },
  { path: '/credentials', icon: 'key',              label: 'Credentials' },
]


const TITLES = {
  '/':           'Tableau de bord',
  '/contacts':   'Contacts',
  '/documents':  'Documents',
  '/produits':   'Catalogue produits',
  '/alertes':    'Alertes / Relances',
  '/parametres': 'Paramètres',
}

const initials = n => (n || '').split(/\s+/).map(w => w[0]).slice(0, 2).join('').toUpperCase()
const today = new Date().toLocaleDateString('fr-FR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })

export default function Layout() {
  const { user, logout, isAdmin, isTech } = useApp()
  const navigate  = useNavigate()
  const location  = useLocation()
  const active    = location.pathname
  const NAV       = isAdmin ? NAV_ADMIN : NAV_TECH

  return (
    <div className="app">
      {/* Sidebar */}
      <div className="sidebar">
        <div className="logo">
          <i className="ti ti-hexagon" style={{ fontSize: 22 }} />
          <span>HubSpot</span>
        </div>

        <div className="nav-section" style={{ flex: 1 }}>
          <div className="nav-label">Navigation</div>
          {NAV.map(n => (
            <div
              key={n.path}
              className={`nav-item${active === n.path ? ' active' : ''}`}
              onClick={() => navigate(n.path)}
            >
              <i className={`ti ti-${n.icon}`} />
              <span>{n.label}</span>
            </div>
          ))}
        </div>

        <div style={{ borderTop: '1px solid var(--border)', padding: '8px 0' }}>
          <div className="nav-item" style={{ cursor: 'default' }}>
            <div className="avatar" style={{ width: 26, height: 26, fontSize: 10 }}>
              {initials(`${user?.prenom || ''} ${user?.nom || ''}`)}
            </div>
            <span style={{ fontSize: 12, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', maxWidth: 130 }}>
              {user?.prenom} {user?.nom}
            </span>
          </div>
          <div className="nav-item" onClick={logout}>
            <i className="ti ti-logout" />
            <span>Déconnexion</span>
          </div>
        </div>
      </div>

      {/* Main */}
      <div className="main">
        <div className="topbar">
          <h1 className="topbar-title">{TITLES[active] || 'HubSpot'}</h1>
          <span style={{ fontSize: 12, color: 'var(--text3)' }}>{today}</span>
        </div>
        <Outlet />
      </div>
    </div>
  )
}
